module.exports = {
    message: {
        homeNavi: 'Home',
        aboutNavi: 'About',
        testNavi: 'Test',
        hello: 'Hello World',
        welcome: 'This is a simple project using Vuejs and TypeScript.',
        welcomeParagraphs: 'This is BanG Dream! moe website\'s home page. Before, it was not enabled and displayed the Nginx installation success page. But according to the website development plan, the home page will add some features. Now you seeing this page represents the website is under construction, please wait.',
    }
}